import { render, staticRenderFns } from "./BAEventParticipants.vue?vue&type=template&id=3da5cc5e&"
import script from "./BAEventParticipants.vue?vue&type=script&lang=ts&"
export * from "./BAEventParticipants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports